module.exports = __webpack_public_path__ + "img/ic_myclass.eef95424.svg";